import React, {Component} from 'react';
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

class InputDatePicker extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        value: PropTypes.objectOf(Date).isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        className: null,
        locale: 'de',
        isRequired: false,
        disabled: false,
    };

    constructor(props) {

        super(props);

        this.state = {
            value: (props.value) ? props.value : new Date()
        };

        this.onValueChange = this.onValueChange.bind(this);
        this.validateDate = this.validateDate.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.value !== this.props.value) {
            this.setState({
                value: nextProps.value
            });
        }

    }

    onValueChange(date) {

        if (!this.props.disabled) {
            if (this.props.onChange) this.props.onChange(null, this.props.name, date, this.validateDate(date));

            this.setState({
                value: date
            });
        }

    }

    validateDate(date) {

        return (date.getTime() === date.getTime());

    }

    render() {

        return (
            <DatePicker
                className={this.props.className ? this.props.className : "form-control"}
                selected={this.props.value}
                onChange={this.onValueChange}
                locale={this.props.locale}
                required={this.props.isRequired}
                disabled={this.props.disabled}
                dateFormat="dd.MM.yyyy"
            />
        );

    }

}

export default InputDatePicker;